import { NgModule } from '@angular/core';
import { NgxMaskDirective } from 'ngx-mask';

@NgModule({
    imports: [NgxMaskDirective],
    exports: [NgxMaskDirective],
})
export class NgxMaskWrapperModule {}